import React, { useContext } from "react";
import FloatCard from "./ui/FloatCard";
import styled from "styled-components";
import { General } from "../tools/styles";
import {WatchContext} from '../WatchContext'
// import { theme } from "../theme";

const Styles = {
  Title: styled.span`
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.grey3};
  `,
  SmallHead: styled.h2`
    font-size: 1.4rem;
    text-transform: capitalize;
    text-align: center;
  `,
};

const PermitStatus = () => {

  const { permit } = useContext(WatchContext);
  const selectedPermits = permit.permits.filter((permit) => permit.selected);

  const permitElems = selectedPermits.map(permit => {
    let completedTasks = permit.requirements?.filter(req => req.evaluated).length ?? 0
  let totalTasks = permit.requirements?.length ?? 0
  return (
    <div style={{border: '1px solid black', width: '100%', padding: '1rem 2rem'}}>
    <span style={{textAlign: 'center'}}>{permit.permit}</span><br/>
    <span>{completedTasks} of {totalTasks} tasks completed</span>
    </div>
  )})

  
  

  return (
    
      <General.ColBlock bgColor='inherit' align="flex-start" justify="center">
        <Styles.SmallHead>Permit Progress</Styles.SmallHead>
       {selectedPermits.length === 0 ? 'No permit selected' : permitElems}
      </General.ColBlock>
    
  );
};

export default PermitStatus;
